
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/type/promoted",
      function () {
        return require("private-next-pages/type/promoted.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/type/promoted"])
      });
    }
  